<style scoped>
.btn-edit {
  width: 25px;
  height: 30px;
  border: 1px solid gray;
  cursor: pointer;
  position: relative;
}
.btn-edit-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 12px;
}
</style>

<template>
  <div>
    <div class="mb-3 justify-content-evenly rounded-3 p-1">
      <input
        class="text-center rounded mb-0 fs-5"
        style="border: 0px; width: 30px"
        value="0"
        readonly
        role="button"
        data-bs-toggle="popover"
        data-bs-trigger="focus"
        data-bs-custom-class="bg-white"
        v-model="inputValue"
        @click="toggleNumberKeyBoard()"
      />
    </div>
    <input-number-keyborad></input-number-keyborad>
  </div>
</template>



<script>
export default {
  name: "PosAmount",
  props: ["value", "index", "updateUri"],
  data() {
    return {
      inputValue: 0,
      total: 0,
    };
  },
  mounted() {
    this.inputValue = this.value;
  },
  watch: {
    value(newValue, old) {
      this.inputValue = newValue;
    },
  },
  methods: {
    getInputValue() {
      return this.inputValue;
    },
    setInputValue(value) {
      this.inputValue = value;
    },
    toggleNumberKeyBoard() {
      this.$children[0].setIsOpen(!this.$children[0].getIsOpen());
      this.$children[0].getProductAmount();
    },
    async updateOnlyAmount() {
      if (this.inputValue <= 0) {
        mySwal.fire({
          title: "ไม่สามารถอัปเดตสินค้าได้",
          text: `จำนวนต้องมีค่ามากกว่า 0`,
          icon: "error",
        });
        this.inputValue = this.value;
        return;
      }
      if (this.$root.orderDetails.length > this.index) {
        let current_cart = this.$root.orderDetails;
        let cart_details = this.$root.cartDetails;
        let data = {
          index: this.index,
          current_cart,
          cart_details,
          amount: this.inputValue,
        };
        let res = null;
        window.loading_on();
        try {
          res = await axios.post(this.updateUri, data);
        } catch (error) {
          errorPos();
        }
        window.loading_off();
        this.$root.isOverLimit(res.data.is_over_limit);
        this.$root.orderDetails = res.data.cart;
        this.$root.cartDetails = res.data.calculated_cart;
      }
      this.$root.calculateDiscount();
      this.$root.updateDiscount();
    },
  },
};
</script>

